import { ActionTypes } from "../constants/index";

export default function users(
	state = {
		isFetching: false,
	},
	action = ""
) {
	switch (action.type) {
		case ActionTypes.FETCH_USERS_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				users: action.users,
			});
		case ActionTypes.UPDATE_USER:
			return Object.assign({}, state, {
				users: state.users.map((item) => {
					return item.id === action.user.id ? action.user : item;
				}),
			});
		default:
			return state;
	}
}
